module.exports = "//cdn.mxpnl.com/static/asset-cache/34022a80496ad8978afd96e444b5553b/iron/common/widgets/custom-property-modal/ace-gutter-error.svg";